import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { withRouter } from 'react-router-dom';

import { mediaCtrStatistics } from 'lib/api/media';
import { makeRowColumn, getHeadObj, dayColor } from 'lib/commonLib';

import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

const MediaCtrStatistics = () => {
  const initParams = {
    sort: 'desc',
    order: '30AVG_CLICK_RATE',
    pltfomTpCode: 'all',
    type: 'clickRate',
  };

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  // header 및 body 컬럼 커스텀
  const customized = {
    SPNAME: {
      merged: true,
    },
    '7AVG_CLICK_RATE': {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, '7AVG_CLICK_RATE').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const pname = getHeadObj(headsMap, '7AVG_CLICK_RATE');

        return (
          <>
            <span
              style={getRafColor(rowObj, '7AVG_CLICK_RATE')}
              title={rowObj['7AVG_CLICK_RATE']}
            >
              {makeRowColumn(
                rowObj['7AVG_CLICK_RATE'],
                pname.type,
                pname.format
              )}
            </span>
          </>
        );
      },
    },
    '14AVG_CLICK_RATE': {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, '14AVG_CLICK_RATE').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const pname = getHeadObj(headsMap, '14AVG_CLICK_RATE');

        return (
          <>
            <span
              style={getRafColor(rowObj, '14AVG_CLICK_RATE')}
              title={rowObj['14AVG_CLICK_RATE']}
            >
              {makeRowColumn(
                rowObj['14AVG_CLICK_RATE'],
                pname.type,
                pname.format
              )}
            </span>
          </>
        );
      },
    },
    '30AVG_CLICK_RATE': {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, '30AVG_CLICK_RATE').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const pname = getHeadObj(headsMap, '30AVG_CLICK_RATE');

        return (
          <>
            <span
              style={getRafColor(rowObj, '30AVG_CLICK_RATE')}
              title={rowObj['30AVG_CLICK_RATE']}
            >
              {makeRowColumn(
                rowObj['30AVG_CLICK_RATE'],
                pname.type,
                pname.format
              )}
            </span>
          </>
        );
      },
    },
    '90AVG_CLICK_RATE': {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, '90AVG_CLICK_RATE').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const pname = getHeadObj(headsMap, '90AVG_CLICK_RATE');

        return (
          <>
            <span
              style={getRafColor(rowObj, '90AVG_CLICK_RATE')}
              title={rowObj['90AVG_CLICK_RATE']}
            >
              {makeRowColumn(
                rowObj['90AVG_CLICK_RATE'],
                pname.type,
                pname.format
              )}
            </span>
          </>
        );
      },
    },
    '1DAY_CLICK_RATE': {
      makeHead: (headsMap) => {
        const DAY_LAVEL = moment().add(-1, 'day');
        return dayColor(DAY_LAVEL, 'date', 'MM-DD');
      },
      makeBody: (rowObj, headsMap) => {
        const pname = getHeadObj(headsMap, '1DAY_CLICK_RATE');

        return (
          <>
            <span
              style={getRafColor(rowObj, '1DAY_CLICK_RATE')}
              title={rowObj['1DAY_CLICK_RATE']}
            >
              {makeRowColumn(
                rowObj['1DAY_CLICK_RATE'],
                pname.type,
                pname.format
              )}
            </span>
          </>
        );
      },
    },
    '2DAY_CLICK_RATE': {
      makeHead: (headsMap) => {
        const DAY_LAVEL = moment().add(-2, 'day');
        return dayColor(DAY_LAVEL, 'date', 'MM-DD');
      },
      makeBody: (rowObj, headsMap) => {
        const pname = getHeadObj(headsMap, '2DAY_CLICK_RATE');

        return (
          <>
            <span
              style={getRafColor(rowObj, '2DAY_CLICK_RATE')}
              title={rowObj['2DAY_CLICK_RATE']}
            >
              {makeRowColumn(
                rowObj['2DAY_CLICK_RATE'],
                pname.type,
                pname.format
              )}
            </span>
          </>
        );
      },
    },
    '3DAY_CLICK_RATE': {
      makeHead: (headsMap) => {
        const DAY_LAVEL = moment().add(-3, 'day');
        return dayColor(DAY_LAVEL, 'date', 'MM-DD');
      },
      makeBody: (rowObj, headsMap) => {
        const pname = getHeadObj(headsMap, '3DAY_CLICK_RATE');

        return (
          <>
            <span
              style={getRafColor(rowObj, '3DAY_CLICK_RATE')}
              title={rowObj['3DAY_CLICK_RATE']}
            >
              {makeRowColumn(
                rowObj['3DAY_CLICK_RATE'],
                pname.type,
                pname.format
              )}
            </span>
          </>
        );
      },
    },
    '4DAY_CLICK_RATE': {
      makeHead: (headsMap) => {
        const DAY_LAVEL = moment().add(-4, 'day');
        return dayColor(DAY_LAVEL, 'date', 'MM-DD');
      },
      makeBody: (rowObj, headsMap) => {
        const pname = getHeadObj(headsMap, '4DAY_CLICK_RATE');

        return (
          <>
            <span
              style={getRafColor(rowObj, '4DAY_CLICK_RATE')}
              title={rowObj['4DAY_CLICK_RATE']}
            >
              {makeRowColumn(
                rowObj['4DAY_CLICK_RATE'],
                pname.type,
                pname.format
              )}
            </span>
          </>
        );
      },
    },
    '5DAY_CLICK_RATE': {
      makeHead: (headsMap) => {
        const DAY_LAVEL = moment().add(-5, 'day');
        return dayColor(DAY_LAVEL, 'date', 'MM-DD');
      },
      makeBody: (rowObj, headsMap) => {
        const pname = getHeadObj(headsMap, '5DAY_CLICK_RATE');

        return (
          <>
            <span
              style={getRafColor(rowObj, '5DAY_CLICK_RATE')}
              title={rowObj['5DAY_CLICK_RATE']}
            >
              {makeRowColumn(
                rowObj['5DAY_CLICK_RATE'],
                pname.type,
                pname.format
              )}
            </span>
          </>
        );
      },
    },
    '6DAY_CLICK_RATE': {
      makeHead: (headsMap) => {
        const DAY_LAVEL = moment().add(-6, 'day');
        return dayColor(DAY_LAVEL, 'date', 'MM-DD');
      },
      makeBody: (rowObj, headsMap) => {
        const pname = getHeadObj(headsMap, '6DAY_CLICK_RATE');

        return (
          <>
            <span
              style={getRafColor(rowObj, '6DAY_CLICK_RATE')}
              title={rowObj['6DAY_CLICK_RATE']}
            >
              {makeRowColumn(
                rowObj['6DAY_CLICK_RATE'],
                pname.type,
                pname.format
              )}
            </span>
          </>
        );
      },
    },
    '7DAY_CLICK_RATE': {
      makeHead: (headsMap) => {
        const DAY_LAVEL = moment().add(-7, 'day');
        return dayColor(DAY_LAVEL, 'date', 'MM-DD');
      },
      makeBody: (rowObj, headsMap) => {
        const pname = getHeadObj(headsMap, '7DAY_CLICK_RATE');

        return (
          <>
            <span
              style={getRafColor(rowObj, '7DAY_CLICK_RATE')}
              title={rowObj['7DAY_CLICK_RATE']}
            >
              {makeRowColumn(
                rowObj['7DAY_CLICK_RATE'],
                pname.type,
                pname.format
              )}
            </span>
          </>
        );
      },
    },
    '8DAY_CLICK_RATE': {
      makeHead: (headsMap) => {
        const DAY_LAVEL = moment().add(-8, 'day');
        return dayColor(DAY_LAVEL, 'date', 'MM-DD');
      },
      makeBody: (rowObj, headsMap) => {
        const pname = getHeadObj(headsMap, '8DAY_CLICK_RATE');

        return (
          <>
            <span
              style={getRafColor(rowObj, '8DAY_CLICK_RATE')}
              title={rowObj['8DAY_CLICK_RATE']}
            >
              {makeRowColumn(
                rowObj['8DAY_CLICK_RATE'],
                pname.type,
                pname.format
              )}
            </span>
          </>
        );
      },
    },
    '9DAY_CLICK_RATE': {
      makeHead: (headsMap) => {
        const DAY_LAVEL = moment().add(-9, 'day');
        return dayColor(DAY_LAVEL, 'date', 'MM-DD');
      },
      makeBody: (rowObj, headsMap) => {
        const pname = getHeadObj(headsMap, '9DAY_CLICK_RATE');

        return (
          <>
            <span
              style={getRafColor(rowObj, '9DAY_CLICK_RATE')}
              title={rowObj['9DAY_CLICK_RATE']}
            >
              {makeRowColumn(
                rowObj['9DAY_CLICK_RATE'],
                pname.type,
                pname.format
              )}
            </span>
          </>
        );
      },
    },
    '10DAY_CLICK_RATE': {
      makeHead: (headsMap) => {
        const DAY_LAVEL = moment().add(-10, 'day');
        return dayColor(DAY_LAVEL, 'date', 'MM-DD');
      },
      makeBody: (rowObj, headsMap) => {
        const pname = getHeadObj(headsMap, '10DAY_CLICK_RATE');
        return (
          <>
            <span
              style={getRafColor(rowObj, '10DAY_CLICK_RATE')}
              title={rowObj['10DAY_CLICK_RATE']}
            >
              {makeRowColumn(
                rowObj['10DAY_CLICK_RATE'],
                pname.type,
                pname.format
              )}
            </span>
          </>
        );
      },
    },
  };

  const getRafColor = (rowObj, key) => {
    let color = 'green';
    if (rowObj[key] > rowObj['30AVG_CLICK_RATE'] * 1.1) color = 'blue';
    else if (rowObj[key] < rowObj['30AVG_CLICK_RATE'] * 0.9) color = 'red';
    return { color: color };
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          params={params}
          getParam={getParam}
          useDate={false}
          useExternalFilter={false}
        />
      </NewFilterWrap>
      <NewTableContainer
        dataReqPromise={mediaCtrStatistics}
        params={params}
        getParam={getParam}
        customized={customized}
      />
    </>
  );
};

export default withRouter(MediaCtrStatistics);
